import React from 'react';
import { Box, FormControl, Select, Typography, alpha, useTheme } from '@mui/material';

interface StyledSelectProps {
  label: string;
  accentColor?: 'primary' | 'secondary' | 'success' | 'error';
  value?: any;
  onChange?: (event: any) => void;
  children?: React.ReactNode;
  sx?: any;
  [key: string]: any;
}

const StyledSelect: React.FC<StyledSelectProps> = ({ 
  label, 
  accentColor = 'primary',
  children,
  sx,
  ...props 
}) => {
  const theme = useTheme();
  
  const getAccentColor = () => {
    switch (accentColor) {
      case 'secondary': return theme.palette.secondary.main;
      case 'success': return theme.palette.success.main;
      case 'error': return theme.palette.error.main;
      default: return theme.palette.primary.main;
    }
  };

  const color = getAccentColor();

  return (
    <Box sx={{ position: 'relative', width: '100%' }}>
      <Typography 
        variant="caption" 
        sx={{ 
          position: 'absolute', 
          top: -10, 
          left: 12, 
          bgcolor: 'background.paper', 
          px: 1, 
          zIndex: 1, 
          color: color,
          fontWeight: 700,
          textTransform: 'uppercase',
          letterSpacing: '0.1em',
          fontSize: '0.65rem'
        }}
      >
        {label}
      </Typography>
      <FormControl fullWidth>
        <Select
          {...props}
          size="small"
          sx={{ 
            borderRadius: 2,
            bgcolor: 'rgba(0,0,0,0.4)',
            '& .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(255,255,255,0.1)' },
            '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: alpha(color, 0.3) + ' !important' },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: color + ' !important' },
            ...sx
          }}
        >
          {children}
        </Select>
      </FormControl>
    </Box>
  );
};

export default StyledSelect;
